import { render } from "./cart-freebie-card.vue?vue&type=template&id=aa202034"
import script from "./cart-freebie-card.vue?vue&type=script&lang=js"
export * from "./cart-freebie-card.vue?vue&type=script&lang=js"

import "./cart-freebie-card.vue?vue&type=style&index=0&id=aa202034&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__